<template>
  <b-container class="pt-2 pl-0 pr-0">
    <b-row v-if="comments" align-h="center" class="pl-0 pr-0">
      <b-col :cols="level - 1"/>
      <b-col :cols="12 - level + 1">
        <b-card no-body class="mb-1" v-for="(key, index) in keys" :key="index" >
          <b-card-header header-tag="header" class="p-1 text-center" role="tab" v-if="!Array.isArray(comments.get(key)) || level === 1">
            <b-container>
              <b-row>
                <b-col cols="7" class="text-left">
                  <h2>{{ key }}</h2>
                </b-col>
                <b-col cols="3">
                  <b-btn block href="#" v-b-toggle="`accordion${index}-${myId}`" variant="outline-primary" size="sm">
                    Expand/Collapse
                  </b-btn>
                </b-col>
                <b-col cols="2">
                  <a class='clickable' @click="copy(Array.isArray(comments.get(key)) ? `accordion${index}-${myId}` : `comment-card-${index}-${myId}`)">
                    <font-awesome-icon icon="copy" size="1x"/> <small>Copy</small>
                  </a>
                </b-col>
              </b-row>
            </b-container>
          </b-card-header>
          <b-collapse :id="`accordion${index}-${myId}`" :accordion="`accordion${index}-${myId}`" role="tabpanel" :visible="level > 1">
            <b-card-body>
              <b-container class="text-left" v-if="Array.isArray(comments.get(key))">
                <span v-if="level > 1" >{{ key }}</span>
                <ul>
                  <li v-for="(comment, index1) in comments.get(key)" :key="index1">
                    <span v-html="comment.userComment"/>
                  </li>
                </ul>
                <br>&nbsp;
              </b-container>
              <CommentsSection :id="`comment-card-${index}-${myId}`" v-else :level="level + 1" :comments="comments.get(key)"/>
            </b-card-body>
          </b-collapse>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>

export default {
  name: 'CommentsSection',
  props: {
    level: {
      default: 1,
      type: Number
    },
    comments: {
      default: false,
      type: Map
    }
  },
  data: function () {
    return {
      myId: Math.round(Math.random() * 100000)
    };
  },
  computed: {
    keys () {
      return Array.from(this.comments.keys());
    }
  },
  methods: {
    copy(id) {
      const range = document.createRange();
      range.selectNode(document.getElementById(id));
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();
    }
  },
  created() {
    console.log(JSON.stringify(this.comments, null, 2));
  }

}
</script>
<style>
.btn{
    white-space:normal !important;
    word-wrap: break-word; 
}
</style>


// WEBPACK FOOTER //
// src/components/CommentsSection.vue